import React, { useEffect, useState } from "react"
import { OPACITY_HIGHLIGHT_LEVELS } from "../consts/modules/graphics.consts"
import { debounce } from "lodash"

/**
 * Custom hook to manage chart data highlighting on legend hover
 *
 * @param {Array} initialData
 * @returns
 */
const useHighlightChartData = ({
  initialData,
  highlightLevels = {
    highlighted: OPACITY_HIGHLIGHT_LEVELS.HIGHLIGHTED,
    notHighlighted: OPACITY_HIGHLIGHT_LEVELS.NOT_HIGHLIGHTED,
  },
  highlightFilters = {
    highlighted: "saturate(1)",
    notHighlighted: "saturate(1)",
  },
}) => {
  const [data, setData] = useState(initialData)
  const debouncedSetData = debounce(setData, 50)

  useEffect(() => {
    setData(initialData)
  }, [initialData])

  const handleMouseEnterLegend = (e) => {
    const hoveredLegend = e?.currentTarget?.dataset?.name
    if (!data?.length) {
      return
    }
    data[0].data = data[0].data.map((item) => ({
      ...item,
      extraInfo: {
        ...item.extraInfo,
        filter:
          item.name === hoveredLegend ?
            highlightFilters.highlighted
          : highlightFilters.notHighlighted,
        opacity:
          item.name === hoveredLegend ?
            highlightLevels.highlighted
          : highlightLevels.notHighlighted,
      },
    }))
    debouncedSetData([...data])
  }
  const handleMouseLeaveLegend = (e) => {
    if (!data?.length) {
      return
    }
    data[0].data = data[0].data.map((item) => ({
      ...item,
      extraInfo: {
        ...item.extraInfo,
        filter: highlightFilters.highlighted,
        opacity: highlightLevels.highlighted,
      },
    }))
    debouncedSetData([...data])
  }

  return {
    data,
    setData,
    handleMouseEnterLegend,
    handleMouseLeaveLegend,
  }
}

export default useHighlightChartData
